import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import Cookie from 'utils/cookies';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { UNIFIED_FEED_DOMAIN_SERVICE, TOI_LIVE_DOMAIN, TOI_IMAGE_DOMAIN } from 'constants/index';
import makeRequest from 'utils/makeRequest';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';

import GameOverlay from '../GameOverlay/GameOverlay';
import HowToPlay from '../HowToPlay/HowToPlay';
import { loadSyncUp, loadConnectStateSave } from '../../../redux';

import s from './ConnectGame.scss';
import CongratulationsNew from '../CongratulationsNew/CongratulationsNew';
// import PracticeCard from '../PracticeCard/PracticeCard';
import breadcrumbs from '../../../GameBreadcrumbsHelper';
import BreadCrumb from '../../../../../components_v2/common/BreadCrumb/BreadCrumb';
import ShareButton from '../ShareButton/ShareButton';
import MoreOnGames from '../MoreOnGames/MoreOnGames';
import { postMessage } from '../../common/Map/utils';
import {
  fireGa4andGrx,
  initializeIframeMessageListener,
  checkIframeUserLogin,
  formatTimeMMSS,
  timeStringToMilliseconds,
} from '../../../layouts/utils';

const useGameState = props => {
  const { apiConfigData, puzzleAPI, levelData, isWebView } = props;
  const configSaveStateCounter = apiConfigData?.saveStateTimerValueInSec || 5;
  const gameId = levelData?.gameID || puzzleAPI?.gameId || '';
  const jsonUrl = levelData?.deeplink || puzzleAPI?.url || '';

  // Initialize grxId and ssoId
  let grxId = '';
  let ssoId = '';
  if(isWebView){
    grxId = props.grxId || '';
  } else {
    grxId = Cookie.get('_grx') || '';
  }
  ssoId = Cookie.get('ssoid') || '';

  return { configSaveStateCounter, gameId, jsonUrl, grxId, ssoId, levelData };
};

const isLocalStorageAvailable = () =>
  typeof localStorage !== 'undefined' && localStorage !== null;

const ConnectGame = props => {
  const {
    isMobile,
    userData,
    todaysGame,
    isToday,
    handleGameCallback,
    buttonClicked,
    iframeSource,
    iframeLangSource,
    isGameIframe,
    iframeLang,
    isWebView,
    isResultView,
    theme,
    fv,
    pfm,
    gameSolutionData,
    viewSolution,
    gamejsonUrl,
    gamesolLevel,
  } = props;
  const {
    configSaveStateCounter,
    gameId,
    jsonUrl,
    grxId,
    ssoId,
    levelData,
  } = useGameState({ ...props });
  const commonTranslations = _get(
    props,
    'gamesconfigData.translations.commonTranslations',
    {},
  );
  const gameSpecificTranslations = _get(
    props,
    'gamesconfigData.translations.gameSpecificTranslations.connect',
    {},
  );

  const browsingPlatform = isWebView ? 'webview' : isMobile ? 'mweb' : 'web';

  const [showLoader, setLoader] = useState(true);
  const [puzzle, setPuzzle] = useState([]);
  const [dim, setDim] = useState([]);
  const [timer, setTimer] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [status, setStatus] = useState('playing');
  const [showOverlay, setShowOverlay] = useState(false);
  const [popUpType, setPopUpType] = useState('');
  const [failedAPI, setFailedAPI] = useState('');
  const [showCongrate, setCongrate] = useState(false);
  const [resultData, setResultData] = useState(undefined);
  const [hasSynced, setHasSynced] = useState(false);
  const [isHintCooldown, setHintCooldown] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '' });
  const [todaysGameApp, setTodaysGame] = useState(true);
  const [gameSolutionAPIData, setGameSolutionAPIData] = useState(null);

  const [gameState, setGameState] = useState({
    path: [],
    isDrawing: false,
    solutionPath: [],
    hintsUsed: 0,
    highlightedCell: null,
  });

  const gridContainerRef = useRef(null);
  const timerIntervalRef = useRef(null);
  const isWebDataInitializedRef = useRef(false);
  const todaysGameRef = useRef(true);

  // Check completion
  useEffect(
    () => {
      if (
        gameState?.path?.length === puzzle.size * puzzle.size &&
        gameState.path[gameState?.path?.length - 1][0] === puzzle.end[0] &&
        gameState.path[gameState?.path?.length - 1][1] === puzzle.end[1]
      ) {
        //console.log('setGameState>>1', gameState);
        setGameState(prev => ({...prev}));
        setTimeout(() => {
          setGameState(prev => ({ ...prev }));
        }, 3000);
      }
    },
    [gameState?.path, puzzle],
  );

  const timerRef = useRef(null);
  const isPausedRef = useRef(false);
  const userDataRef = useRef(userData);

  useEffect(
    () => {
      if (gameState && timer && timer > 0) {
        if (!showCongrate) {
          if (isLocalStorageAvailable()) {
            if (isGameIframe && iframeSource) {
              localStorage.setItem(
                `${iframeSource}connect:${gameId}`,
                JSON.stringify({ timer, gameState }),
              );
            } else {
              localStorage.setItem(
                `tilconnect:${gameId}`,
                JSON.stringify({ timer, gameState }),
              );
            }
          }
        }
        timerRef.current = timer || timerRef.current;
      }
    },
    [timer],
  );

  const fireGa = (ga4Type, ga4Category, ga4Label) => {
    analyticsWrapper('grx', 'track', 'user_click', {
      event: 'user_click',
      type: ga4Type,
      category: ga4Category,
      label: ga4Label,
    });
  };

  const fireGaGameScreen = (gaLabelText, score = '', gaType) => {
    const gaData = {
      event: 'user_shown_games',
      type: gaType || 'gameplay_screen',
      label: gaLabelText,
      page_template: 'gameplay',
      section: 'games',
      subsection: 'connect',
      browsing_platform: browsingPlatform,
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    if (score) {
      gaData.score = score;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  const overlayCall = (type) => {
    setShowOverlay(true);
    setPopUpType(type);
  };

  const gameStateSaveCall = () => {
    let locatStateData;
      if (isGameIframe && iframeSource) {
        locatStateData = JSON.parse(
          localStorage.getItem(`${iframeSource}connect:${gameId}`),
        );
      } else {
        locatStateData = JSON.parse(
          localStorage.getItem(`tilconnect:${gameId}`),
        );
      }
    if (
      typeof props.loadConnectStateSave === 'function' &&
      userData?.isLoggedIn &&
      todaysGame
    ) {
      
      try {
        if(!isWebView || todaysGameRef.current){
          const params = {
            gameId,
            gameType: 'connect',
            grxId,
            ssoId,
            completionTimeInMillis: (timer || timerRef.current) * 1000,
            connectData: locatStateData?.gameState
          };
          props.loadConnectStateSave(params);
        }
      } catch (e) {
        console.log('game error>>', e);
      }
    }
    if(isWebView && !isResultView){
      const stData = JSON.stringify({
        timer: timerRef.current,
        gameState: locatStateData?.gameState,
      });
      //console.log('insidegameStateSaveCallstData>>', stData)
      postMessage('saveWebGameData', stData);
    }
  };

  const clearLocalStorage = key => {
    try {
      if (isLocalStorageAvailable()) {
        localStorage.removeItem(key);
      }
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  };

  const startTimer = (init = false) => {
    if (timerIntervalRef.current && !init) return;
    timerIntervalRef.current = setInterval(() => {
      setTimer(prevTimer => {
        const newTimer = prevTimer + 1;
        if (newTimer % configSaveStateCounter === 0) {
          gameStateSaveCall();
        }
        return newTimer;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (timerIntervalRef.current) {
      clearInterval(timerIntervalRef.current);
      timerIntervalRef.current = null;
    }
  };

  const playTimer = () => {
    if (isPausedRef.current) {
      startTimer();
      isPausedRef.current = false;
    }
  };

  const pauseTimer = () => {
    if (!isPausedRef.current) {
      stopTimer();
      isPausedRef.current = true;
    }
  };

  const gameStateFetchCall = (receivedGrxId, receivedSsoId) => {
    let tempGrxId = grxId;
    let tempSsoId = ssoId;

    if (isGameIframe && iframeLangSource) {
      tempGrxId = receivedGrxId || grxId;
      tempSsoId = receivedSsoId || ssoId;
    }
    if (userData?.isLoggedIn && todaysGame && !showCongrate) {
      let url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/get/paused/game?gameId=${gameId}&gameType=connect`;
      if (isGameIframe && iframeLangSource) {
        url = url+`&pc=${iframeLangSource}${iframeLang ? `&lang=${iframeLang}` : ''}&pfm=web`;
      }
      else if(isWebView){
        url = url+`&fv=${fv}&pfm=${pfm}&pc=toi`;
      }
      else
      {
        url = url+`&pc=toi&pfm=web`;
      }
      makeRequest
        .post(url, {}, { headers: { grxId: tempGrxId, ssoId: tempSsoId } })
        .then(data => {
          const stateData = data?.data?.stateConnect;
          const stateConnectAPI = stateData?.connectData;
          const stateConnectTimer = (stateData?.completionTimeInMillis ?? 0) / 1000;
          setTimer(stateConnectTimer);
          const stateConnect = {
            path: stateConnectAPI?.path || [],
            isDrawing: stateConnectAPI?.isDrawing || false,
            solutionPath: stateConnectAPI?.solutionPath || [],
            hintsUsed: stateConnectAPI?.hintsUsed || 0,
          }
          if (!showCongrate) {
            if (isGameIframe && iframeSource) {
              localStorage.setItem(
                `${iframeSource}connect:${gameId}`,
                JSON.stringify({
                  timer: stateConnectTimer,
                  gameState: stateConnect,
                }),
              );
            } else {
              localStorage.setItem(
                `tilconnect:${gameId}`,
                JSON.stringify({
                  timer: stateConnectTimer,
                  gameState: stateConnect,
                }),
              );
            }
          }
          //console.log('setGameState>>2', stateConnect);
          setGameState(stateConnect);
          setLoader(false);
        })
        .catch(err => {
          console.log(err);
          if(isWebView){
            const errorMess = JSON.stringify({type: 'Games',value: `{ failureReason: ${isResultView ? 'RESULT' : 'GAME_PLAY'} }`,requestReason: 'webGameFailure'});
            postMessage('webGameFailure', errorMess);
          }else{
            setFailedAPI('get_paused_api');
            overlayCall('errorPopUp');
          }
          setLoader(false);
        });
    }
    if (isWebDataInitializedRef.current) {
      setLoader(false);
      return; // Already initialized, skip
    }
    startTimer(true);
  };

  const getStatusCall = () => {
    let tempGrxId = grxId;
    let tempSsoId = ssoId;

    if (isGameIframe && iframeSource) {
      const cleanup = initializeIframeMessageListener({
        onLoginStatus: data => {
          if (data && data.userData) {
            // Update grxId and ssoId with iframe data if available
            tempGrxId = data?.userData?.grxId || grxId;
            tempSsoId = data?.userData?.userDetails?.ssoid || ssoId;
          }
          cleanup(); // Clean up listener after receiving data
        },
      });
      // Check login status
      checkIframeUserLogin(iframeSource, iframeLang);
      // return cleanup;
    }

    let url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/status/game?gameId=${gameId}&gameType=connect`;
    if (isGameIframe && iframeLangSource) {
    url = url+`&pc=${iframeLangSource}${iframeLang ? `&lang=${iframeLang}` : ''}&pfm=web`;
    }
    else if(isWebView){
      url = url+`&fv=${fv}&pfm=${pfm}&pc=toi`;
    }
    else
    {
      url = url+`&pc=toi&pfm=web`;
    }
    const requestParams = {
      params: {},
      headers: { grxId: tempGrxId, ssoId: tempSsoId },
    };
    makeRequest
      .get(url, requestParams, 'skipfeedengine')
      .then(data => {
        if (data?.data?.items) {
          if(!isWebView || isResultView){
          if (data?.data?.hasPlayed) {
            const gameCongratulationsData = data?.data?.items?.find(
              item => item?.tn === 'gameCongratulationsData',
            );
            if (gameCongratulationsData?.gameCongratulationsData) {
              setIsSubmitted(true);
              const loggedInResult = !!(grxId && ssoId);
              setResultData({
                ...gameCongratulationsData?.gameCongratulationsData,
                loggedInResult,
              });
              const achievementCards = gameCongratulationsData?.gameCongratulationsData?.achievementCards;
              const tempGameScore =
                Array.isArray(achievementCards) &&
                achievementCards.length > 0 &&
                typeof achievementCards[0]?.primaryText === 'string' &&
                achievementCards[0].primaryText.trim() !== ''
                  ? timeStringToMilliseconds(achievementCards[0].primaryText)
                  : 'N/A';
            fireGaGameScreen('view_results', tempGameScore, 'results_score');
              //console.log('setGameState>>3', data?.data?.connectData?.connectData);
              setGameState(data?.data?.connectData?.connectData);
              setStatus('submitted');
            }
            setLoader(false);
            setCongrate(true);
            if (isLocalStorageAvailable()) {
              if (isGameIframe && iframeSource) {
                clearLocalStorage(`${iframeSource}connect:${gameId}`);
              } else {
                clearLocalStorage(`tilconnect:${gameId}`);
              }
            }
            return;
          }
          }
          gameStateFetchCall(
            tempGrxId,
            tempSsoId,
          );
          setLoader(false);
          fireGaGameScreen(
            buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
          );
        }
        try {
          let savedState;
          if (isLocalStorageAvailable()) {
            if (isGameIframe && iframeSource) {
              savedState = localStorage.getItem(
                `${iframeSource}connect:${gameId}`,
              );
            } else {
              savedState = localStorage.getItem(`tilconnect:${gameId}`);
            }
          }
          if (savedState && !isWebDataInitializedRef.current) {
            const localStateData = JSON.parse(savedState);
            setTimer(localStateData?.timer);
            timerRef.current = localStateData?.timer;
            //console.log('setGameState>>4', localStateData?.gameState);
            setGameState(localStateData?.gameState);
          }
           const eligibleForStateRestore = data?.data?.eligibleForStateRestore ?? false;
          setTodaysGame(eligibleForStateRestore);
          todaysGameRef.current = eligibleForStateRestore;
          gameStateFetchCall(tempGrxId, tempSsoId);
        } catch (error) {
          setFailedAPI('status_api');
          console.error('error inside game js >>', error);
          overlayCall('errorPopUp');
        }
        setLoader(false);
        fireGaGameScreen(
          buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
        );
      })
      .catch(err => {
        console.log(err);
        if(isWebView){
          const errorMess = JSON.stringify({type: 'Games',value: `{ failureReason: ${isResultView ? 'RESULT' : 'GAME_PLAY'} }`,requestReason: 'webGameFailure'});
          postMessage('webGameFailure', errorMess);
        }else{
          setFailedAPI('status_api');
          overlayCall('errorPopUp');
        }
        setLoader(false);
        fireGaGameScreen(
          buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
        );
      });
  };

  // Helper function to apply solution
  const applyConnectSolutionData = (puzzleData, puzzleDim, solutionConnectData, solutionCompletionTime) => {
    if (solutionConnectData && solutionConnectData.path && Array.isArray(solutionConnectData.path) && solutionConnectData.path.length !== 0) {
      const pathLength = solutionConnectData.path.length;
      const puzzleSize = Math.sqrt(pathLength);
      const puzzleStructure = {
        size: puzzleSize,
        start: solutionConnectData.path[0] || [0, 0],
        end: solutionConnectData.path[pathLength - 1] || [puzzleSize - 1, puzzleSize - 1],
        walls: puzzleData?.walls || [],
        solution: solutionConnectData.path
      };
      setPuzzle(puzzleStructure);
      setDim(puzzleSize);
      setTimer(solutionCompletionTime);
      setGameState({
        path: solutionConnectData.path || [],
        isDrawing: false,
        solutionPath: solutionConnectData.solutionPath || [],
        hintsUsed: solutionConnectData.hintsUsed || 0,
        highlightedCell: solutionConnectData.highlightedCell || null,
      });
      setLoader(false);
    }
  }

  const getSolutionData = (puzzleData, puzzleDim) => {
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/fetch/game/solution?pc=toi&pfm=${pfm}&gameId=${gameId}&gameType=connect`;
    const requestParams = {
      params: {},
      headers: {
        grxId,
        ssoId,
      },
    };
    setLoader(true);
    makeRequest
      .get(url, requestParams, 'skipfeedengine')
      .then(data => {
        if (data && data.data) {
          const resData = data.data;
          setGameSolutionAPIData(resData);
          const solutionStateData = resData?.stateConnect;
          const solutionConnectData = solutionStateData?.connectData?.connectData;
          const solutionCompletionTime = (solutionStateData?.completionTimeInMillis ?? 0) / 1000;

          applyConnectSolutionData(puzzleData, puzzleDim, solutionConnectData, solutionCompletionTime);
          setLoader(false);
        }
      })
      .catch(err => {
        console.log(err);
        const errorMess = JSON.stringify({type: 'Games',value: `{ failureReason: ${isResultView ? 'RESULT' : 'GAME_PLAY'} }`,requestReason: 'webGameFailure'});
        //console.log('errorMess>>', errorMess);
        postMessage('webGameFailure', errorMess);
        setLoader(false);
    });
  };

  const getGameJsonCall = () => {
    makeRequest
      .get(jsonUrl, {}, 'skipfeedengine')
      .then(data => {
        const puzzleData = data?.data;
        const puzzleDim = data?.data?.size;
        setPuzzle(puzzleData);
        setDim(puzzleDim);
        if (isResultView) {
          setIsSubmitted(true);
          setStatus('submitted');
          getSolutionData(puzzleData, puzzleDim);
        } else {
          getStatusCall();
        }
        setLoader(false);
      })
      .catch(err => {
        console.log(err);
        if(isWebView){
          const errorMess = JSON.stringify({type: 'Games',value: `{ failureReason: ${isResultView ? 'RESULT' : 'GAME_PLAY'} }`,requestReason: 'webGameFailure'});
          postMessage('webGameFailure', errorMess);
        }else{  
          setFailedAPI('puzzle_api');
          overlayCall('errorPopUp');
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    if (!viewSolution && !gameSolutionData) {
      getGameJsonCall();
    }
  }, [viewSolution, gameSolutionData]);

  const resetConfirmation = () => {
    if(isWebView){
      overlayCall('resetloopaloopapp');
    }
    else{
      overlayCall('resetloopaloop');
    }
  };

  const onReset = check => {
    if (check && isLocalStorageAvailable()) {
      let toigames;
      if (isGameIframe && iframeSource) {
        toigames = JSON.parse(
          localStorage.getItem(`${iframeSource}games`) || '{}',
        );
        toigames.resetPopUpConnect = true;
        localStorage.setItem(`${iframeSource}games`, JSON.stringify(toigames));
      } else {
        toigames = JSON.parse(localStorage.getItem('toigames') || '{}');
        toigames.resetPopUpConnect = true;
        localStorage.setItem('toigames', JSON.stringify(toigames));
      }
    }
    //console.log('setGameState>>5');
    setGameState({
      path: [],
      isDrawing: false,
      solutionPath: [],
      hintsUsed: 0,
      highlightedCell: null,
    });
  };

  const formatTime = time => {
    const hours = String(Math.floor(time / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((time % 3600) / 60)).padStart(2, '0');
    const seconds = String(time % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const hardPause = () => {
    gameStateSaveCall();
    if (typeof handleGameCallback === 'function') {
      handleGameCallback();
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    fireGa4andGrx(
      'pause',
      'user_click_games',
      'gameplay',
      'connect',
      isMobile,
      gameId,
      '',
      levelData?.level?.toLowerCase(),
    );
  };

  const manageTimer = () => {
    if (document.visibilityState === 'hidden') {
      if (!isSubmitted && !showCongrate) {
        hardPause();
        pauseTimer();
      }
    } else if (document.visibilityState === 'visible' && !showCongrate) {
      if (!isSubmitted) {
        playTimer();
      }
    }
  };

  useEffect(
    () => {
      if(!isWebView){
      if (typeof showCongrate !== 'undefined') {
        document.addEventListener('visibilitychange', manageTimer);

        return () => {
          document.removeEventListener('visibilitychange', manageTimer);
          stopTimer();
        };
      }
    }
    },
    [showCongrate],
  );

  const gameOverlayCallback = () => {
    setShowOverlay(false);
  };

  const gameSubmitCall = timeTaken => {
    let url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/submit/game?gameId=${gameId}&gameType=connect`;
    if (isGameIframe && iframeLangSource) {
      url = url+`&pc=${iframeLangSource}${iframeLang ? `&lang=${iframeLang}` : ''}&pfm=web`;
    }
    else if(isWebView){
      url = url+`&fv=${fv}&pfm=${pfm}&pc=toi`;
    }
    else
    {
      url = url+`&pc=toi&pfm=web&fv=1250`;
    }
    const user = userDataRef.current?.isLoggedIn ? userDataRef.current : {};
    const postData = {
      completionTimeInMillis: timeTaken * 1000,
      userName: user?.getFirstName?.() || 'N/A',
      userImage: user?.getIcon?.() || '',
      connectData: { connectData: gameState },
    };
    setLoader(true);

    let tempGrxId = grxId;
    let tempSsoId = ssoId;

    //console.log('ssoId>>', ssoId);

    if (isGameIframe && iframeSource) {
      const cleanup = initializeIframeMessageListener({
        onLoginStatus: data => {
          if (data && data.userData) {
            // Update grxId and ssoId with iframe data if available
            tempGrxId = data?.userData?.grxId || grxId;
            tempSsoId = data?.userData?.userDetails?.ssoid || ssoId;
          }
          cleanup(); // Clean up listener after receiving data
        },
      });
      // Check login status
      checkIframeUserLogin(iframeSource, iframeLang);
      // return cleanup;
    }
    if(isWebView && !isResultView){
      const stData = JSON.stringify({
        timer: timerRef.current,
        gameState: gameState,
      });
      postMessage('saveWebGameData', stData);
    }
    makeRequest
      .post(url, postData, { headers: { grxId: tempGrxId, ssoId: tempSsoId } })
      .then(data => {
        if (data?.data?.items) {
          if(isWebView && !isResultView){
            // Below code is used to keep the response same while sending to App
            let mergedObjData = {
              ...data.data,
              connectData: {
                connectData: postData?.connectData?.connectData
              },
              items: data.data?.items?.map(item => {
                if (item.tn === 'gameCongratulationsData') {
                  return {
                    ...item,
                    gameCongratulationsData: {
                      ...item.gameCongratulationsData,
                      completionTimeInMillis: postData.completionTimeInMillis,
                      brandLogo: `${TOI_IMAGE_DOMAIN}/photo/113318049.cms`,
                      gameIcon: `${TOI_IMAGE_DOMAIN}/photo/122244803.cms`,
                      date: Date.now(),
                      nextPuzzleTime: Date.now() + (24 * 60 * 60 * 1000), // 24 hours from now
                      showNotificationNudge: true
                    }
                  };
                } else if (item.tn === 'practiceMorePuzzle') {
                  return {
                    ...item,
                    practiceMorePuzzleData: {
                      ...item.practiceMorePuzzleData,
                      title: "Practice More Puzzles",
                      icon: `${TOI_IMAGE_DOMAIN}/photo/122244803.cms`,
                      deeplink: "toiapp://open-$|$-id=game-01-$|$-type=gamePreviousPuzzles-$|$-gameType=connect-$|$-isWebGame=true"
                    }
                  };
                } else if (item.tn === 'checkOutMoreGames') {
                  return {
                    ...item,
                    checkOutMoreGamesData: {
                      ...item.checkOutMoreGamesData,
                      title: "Explore More Games",
                      icon: `${TOI_IMAGE_DOMAIN}/photo/110562519.cms`
                    }
                  };
                }
                return item;
              }) || []
            };
            const submitRData = JSON.stringify(mergedObjData);
            // const submitRData = JSON.stringify(data.data);
            postMessage('webGameSubmitted', submitRData);
          }
          const gameCongratulationsData = data?.data?.items?.find(
            item => item?.tn === 'gameCongratulationsData',
          );
          if (gameCongratulationsData?.gameCongratulationsData) {
            const loggedInResult = !!(grxId && ssoId);
            setResultData({
              ...gameCongratulationsData?.gameCongratulationsData,
              loggedInResult,
            });
            const achievementCards = gameCongratulationsData?.gameCongratulationsData?.achievementCards;
            const tempGameScore =
              Array.isArray(achievementCards) &&
              achievementCards.length > 0 &&
              typeof achievementCards[0]?.primaryText === 'string' &&
              achievementCards[0].primaryText.trim() !== ''
                ? timeStringToMilliseconds(achievementCards[0].primaryText)
                : 'N/A';
          fireGaGameScreen('submit_game', tempGameScore, 'results_score');
          }
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setCongrate(true);
          setLoader(false);
        }
        setLoader(false);
        if (isGameIframe && iframeSource) {
          clearLocalStorage(`${iframeSource}connect:${gameId}`);
        } else {
          clearLocalStorage(`tilconnect:${gameId}`);
        }
      })
      .catch(err => {
        console.error(err);
        if(isWebView){
          const errorMess = JSON.stringify({type: 'Games',value: '{ failureReason: GAME_PLAY }',requestReason: 'webGameFailure'});
          postMessage('webGameFailure', errorMess);
        }else{
          setFailedAPI('submit_api');
          overlayCall('errorPopUp');
        }
        setLoader(false);
      });
  };

  const submit = () => {
    stopTimer();
    if (!isSubmitted) {
      setIsSubmitted(true);
      setStatus('submitted');
      gameSubmitCall(timer);
    }
  };

  const callonContinue = (type, check) => {
    switch (type) {
      case 'pausegamepopup':
        playTimer();
        break;
      case 'resetloopaloop':
        onReset(check);
        break;
      case 'resetloopaloopapp':
        onReset(false);
      default:
        break;
    }
  };
  let dimClass = 'easy';
  if (levelData?.level === 'Medium') {
    dimClass = 'medium';
    if (dim?.[0] === 4) {
      dimClass = 'medium gridSeven';
    }
  } else if (levelData?.level === 'Easy') {
    dimClass = 'easy';
    if (dim?.[0] === 5) {
      dimClass = 'easy gridFive';
    }
  } else if (levelData?.level === 'Hard') {
    dimClass = 'hard';
    if (dim?.[0] === 6) {
      dimClass = 'hard gridNine';
    }
  }
  dimClass = viewSolution && gamesolLevel && gamesolLevel !== '' ? gamesolLevel : dimClass;

  const breadCrumbData = isToday
    ? breadcrumbs?.connectToday || []
    : breadcrumbs?.connectPractice || [];

  const gameSyncCall = () => {
    const user = userDataRef.current?.isLoggedIn ? userDataRef.current : {};
    const params = {
      userName: user.getFirstName?.() || 'N/A',
      userImage: user.getIcon?.() || '',
      grxId,
      ssoId,
    };
    props.loadSyncUp(params);
  };

  useEffect(
    () => {
      if (typeof props.loadSyncUp === 'function') {
        userDataRef.current = userData;
        if (userData?.isLoggedIn && !hasSynced) {
          gameSyncCall();
          setHasSynced(true);
        }
      }
    },
    [userData, hasSynced],
  );

  const hasWallMove = (cell1, cell2) =>
    puzzle.walls.some(
      wall =>
        (wall[0][0] === cell1[0] &&
          wall[0][1] === cell1[1] &&
          wall[1][0] === cell2[0] &&
          wall[1][1] === cell2[1]) 
          ||
        (wall[1][0] === cell1[0] &&
          wall[1][1] === cell1[1] &&
          wall[0][0] === cell2[0] &&
          wall[0][1] === cell2[1]),
    );

  // Helper functions
  const hasWall = (cell1, cell2) =>
    puzzle.walls.some(
      wall =>
        (wall[0][0] === cell1[0] &&
          wall[0][1] === cell1[1] &&
          wall[1][0] === cell2[0] &&
          wall[1][1] === cell2[1]) 
        //   ||
        // (wall[1][0] === cell1[0] &&
        //   wall[1][1] === cell1[1] &&
        //   wall[0][0] === cell2[0] &&
        //   wall[0][1] === cell2[1]),
    );

  const areAdjacent = (cell1, cell2) => {
    const rowDiff = Math.abs(cell1[0] - cell2[0]);
    const colDiff = Math.abs(cell1[1] - cell2[1]);
    return (rowDiff === 1 && colDiff === 0) || (rowDiff === 0 && colDiff === 1);
  };

  const getCellFromPosition = e => {
    if (!gridContainerRef.current) return null;

    const rect = gridContainerRef.current.getBoundingClientRect();
    let clientX, clientY;

    if (e.touches) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }

    const x = clientX - rect.left;
    const y = clientY - rect.top;
    const cellSize = rect.width / puzzle.size;

    const col = Math.floor(x / cellSize);
    const row = Math.floor(y / cellSize);

    if (row >= 0 && row < puzzle.size && col >= 0 && col < puzzle.size) {
      return [row, col];
    }
    return null;
  };

  const isCellInPath = (row, col) => {
    // Allow passing through the end cell, but not revisiting other cells
    if (puzzle.end && row === puzzle.end[0] && col === puzzle.end[1]) {
      // Only consider it "in path" if it's the last cell
      return (
        gameState?.path?.length > 0 &&
        gameState?.path[gameState?.path?.length - 1][0] === row &&
        gameState?.path[gameState?.path?.length - 1][1] === col
      );
    }
    return gameState?.path?.some(cell => cell[0] === row && cell[1] === col);
  };

  const getCellWallStyles = (row, col) => {
    const walls = { top: false, right: false, bottom: false, left: false };

    if (row > 0) walls.top = hasWall([row, col], [row - 1, col]);
    if (col < puzzle.size - 1)
      walls.right = hasWall([row, col], [row, col + 1]);
    if (row < puzzle.size - 1)
      walls.bottom = hasWall([row, col], [row + 1, col]);
    if (col > 0) walls.left = hasWall([row, col], [row, col - 1]);

    return walls;
  };

  // Event handlers
  const handleStart = e => {
    const cell = getCellFromPosition(e);
    if (!cell) return;
    // Check if clicking on a cell already in the path
    const cellIndex = gameState?.path?.findIndex(
      pathCell => pathCell[0] === cell[0] && pathCell[1] === cell[1],
    );
    if (cellIndex !== -1) {
      //console.log('setGameState>>6');
      // Cell is already in path - truncate path to this cell
      setGameState(prev => ({
        ...prev,
        path: prev?.path?.slice(0, cellIndex + 1) || [],
        isDrawing: true,
        highlightedCell: null,
      }));
    } else if (cell[0] === puzzle.start[0] && cell[1] === puzzle.start[1]) {
      //console.log('setGameState>>7');
      // Starting fresh from the start cell
      setGameState(prev => ({
        ...prev,
        isDrawing: true,
        path: [cell],
        highlightedCell: null,
      }));
    }
  };
  const handleMove = e => {
    if (!gameState.isDrawing) return;
    const cell = getCellFromPosition(e);
    if (!cell) return;

    const path = gameState?.path || [];
    if (path.length === 0) return;

    const lastCell = path[path.length - 1];

    // If last cell is the end cell, only allow backtracking
    const isAtEndCell =
      puzzle.end &&
      lastCell[0] === puzzle.end[0] &&
      lastCell[1] === puzzle.end[1];

    if (isAtEndCell) {
      // Only allow moving to previous cell in path
      if (path.length > 1) {
        const secondLastCell = path[path.length - 2];
        if (cell[0] === secondLastCell[0] && cell[1] === secondLastCell[1]) {
          setGameState(prev => ({
            ...prev,
            path: prev.path.slice(0, -1),
          }));
        }
      }
      // Do not allow any other moves from end cell
      return;
    }

    // Always allow backtracking by moving to the previous cell in the path
    if (path.length > 1) {
      const secondLastCell = path[path.length - 2];
      if (cell[0] === secondLastCell[0] && cell[1] === secondLastCell[1]) {
        setGameState(prev => ({
          ...prev,
          path: prev.path.slice(0, -1),
        }));
        return;
      }
    }

    // Check for revisiting a cell (except for the end cell)
    const isEndCell =
      puzzle.end && cell[0] === puzzle.end[0] && cell[1] === puzzle.end[1];
    const alreadyInPath = path.some(
      pathCell =>
        pathCell[0] === cell[0] &&
        pathCell[1] === cell[1] &&
        // Allow passing through end cell
        !(isEndCell && pathCell[0] === puzzle.end[0] && pathCell[1] === puzzle.end[1])
    );
    if (alreadyInPath) {
      return;
    }

    if (
      areAdjacent(lastCell, cell) &&
      !hasWallMove(lastCell, cell)
    ) {
      //console.log('setGameState>>9');
      setGameState(prev => ({
        ...prev,
        path: [...prev.path, cell],
      }));
    }
  };

  const handleEnd = () => {
    //console.log('setGameState>>10');
    setGameState(prev => ({ ...prev, isDrawing: false }));
  };

  // Check completion
  useEffect(
    () => {
      //console.log('gameState>>',gameState);
      //console.log('puzzle>>', puzzle);
      if (
        gameState?.path?.length === puzzle.size * puzzle.size &&
        gameState.path[gameState?.path?.length - 1][0] === puzzle.end[0] &&
        gameState.path[gameState?.path?.length - 1][1] === puzzle.end[1]
      ) {
        const gaData = {
          event:  'user_click_games',
          type: 'submit_game',
          category: 'auto_submit',
          label: 'auto_submit',
          page_template: 'gameplay' ,
          section: 'games',
          subsection: 'connect',
          browsing_platform: browsingPlatform,
          game_id: gameId,
          level: levelData?.level?.toLowerCase(),
          game_of_the_day: window.location.href.toLowerCase().includes('/today'),
          score: timer ? timer * 1000 : 'N/A',
          login_status: !!ssoId,
          user_grx_id: grxId,
        };
        if (ssoId) {
          gaData.sso_id = ssoId;
        }
        if (ssoId) {
          gaData.sso_id = ssoId;
        }
        if(!isSubmitted){
          analyticsWrapper('ga4', gaData);
          analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
        }
        submit();
        //console.log('setGameState>>11');
        setGameState(prev => ({...prev}));
        setTimeout(() => {
          setGameState(prev => ({ ...prev }));
        }, 3000);
      }
      else if (
        Array.isArray(gameState?.path) &&
        gameState.path.length &&
        Array.isArray(gameState.path[gameState.path.length - 1]) &&
        gameState.path[gameState.path.length - 1].length > 0 &&
        puzzle &&
        Array.isArray(puzzle.end) &&
        puzzle.end.length >= 2 &&
        gameState.path[gameState.path.length - 1][0] === puzzle.end[0] &&
        gameState.path[gameState.path.length - 1][1] === puzzle.end[1]
      ){
          const message = 'Please fill all empty cells before reaching the end cell';
          setToast({ show: true, message });
          setTimeout(() => setToast({ show: false, message: '' }), 4000);
        }
    },
    [gameState?.path],
  );
  

  const handleHint = () => {
    const gaData = {
      event: 'user_click_games',
      type: 'hint',
      page_template: 'gameplay',
      section: 'games',
      subsection: 'connect',
      browsing_platform: browsingPlatform,
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href
        .toLowerCase()
        .includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper(
      'grx',
      'track',
      'user_click_games',
      gaData,
    );
    if (isHintCooldown) return; // Prevent action during cooldown

    const solution = puzzle.solution;
    let currentPath = gameState.path;
    let nextPath = [];

    // If path is empty, auto-select the start cell
    if (currentPath.length === 0 && puzzle.start) {
      currentPath = [puzzle.start];
    }

    // Find how many steps are correct
    let correctSteps = 0;
    for (let i = 0; i < currentPath.length; i++) {
      if (
        currentPath[i][0] === solution[i][0] &&
        currentPath[i][1] === solution[i][1]
      ) {
        correctSteps++;
      } else {
        break;
      }
    }

    // If path is correct so far, add the next step
    if (correctSteps === currentPath.length && correctSteps < solution.length) {
      nextPath = [...currentPath, solution[correctSteps]];
      //console.log('setGameState>>12');
      setGameState(prev => ({
        ...prev,
        path: nextPath,
        hintsUsed: (prev.hintsUsed || 0) + 1,
        highlightedCell: null,
      }));
    } else {
      // Otherwise, trim back to the last correct step
      nextPath = solution.slice(0, correctSteps);
      let message = '';
      let highlight = null;
      if (correctSteps > 1) {
        message = 'Incorrect moves removed. Continue from the highlighted cell.';
        highlight = solution[correctSteps - 1];
      } else {
        message = 'All moves removed. Begin again from the Start cell.';
        highlight = puzzle.start;
      }
      setToast({ show: true, message });
      setTimeout(() => setToast({ show: false, message: '' }), 4000);
      //console.log('setGameState>>13');
      setGameState(prev => ({
        ...prev,
        path: nextPath,
        hintsUsed: (prev.hintsUsed || 0) + 1,
        highlightedCell: highlight,
      }));
    }

    setHintCooldown(true);
    setTimeout(() => setHintCooldown(false), 5000);
  };

  const howtoPlay = () => {
    overlayCall('howToPlayConnect');
  };

  useEffect(() => {
    postMessage('initWebGameDataRequest');
    window.initialiseGameWebData = response => {
      if (isWebDataInitializedRef.current) return; // Prevent double init
      //console.log('app response>>', response);
      if (response && typeof response === 'string') {
        const responseData = JSON.parse(response);
        setTimer(responseData?.timer);
        timerRef.current = responseData?.timer;
        const stateConnectAPI = responseData?.gameState;
        const stateConnect = {
          path: stateConnectAPI?.path || [],
          isDrawing: stateConnectAPI?.isDrawing || false,
          solutionPath: stateConnectAPI?.solutionPath || [],
          hintsUsed: stateConnectAPI?.hintsUsed || 0,
        };
        //console.log('gameId>>', gameId);
        localStorage.setItem(
          `tilconnect:${gameId}`,
          JSON.stringify({
            timer: responseData?.timer,
            gameState: stateConnect,
          }),
        );
        //console.log('setGameState>>14');
        setGameState(stateConnect);
        isPausedRef.current = false;
        setLoader(false);
        startTimer();
        isWebDataInitializedRef.current = true; // Mark as initialized
      }
    };

    window.publishGameState = gameState => {
      switch (gameState) {
        case 'GAME_PAUSE':
          //console.log('paused>>', gameState);
          gameStateSaveCall();
          pauseTimer();
          break;
        case 'GAME_RESUME':
          //console.log('resumed>>', gameState);
          playTimer();
          break;
        case 'GAME_EXIT': {
          //console.log('exit>>', gameState);
          gameStateSaveCall();
          stopTimer();
          break;
        }
        default:
          console.warn('Unknown gameState>>', gameState);
      }
    };
    //window.initialiseGameWebData('{"timer":1872,"gameState":{"path":[[3,0],[2,0],[1,0],[0,0],[0,1],[0,2],[0,3],[1,3],[2,3],[3,3],[3,2],[2,2],[1,2]],"isDrawing":false,"solutionPath":[],"hintsUsed":0,"highlightedCell":null}}');
  }, []);

    // Show solution data
    useEffect(() => {
      if (viewSolution && gameSolutionData && gamejsonUrl) {
        setLoader(true);
        makeRequest
        .get(gamejsonUrl, {}, 'skipfeedengine')
        .then(data => {
          const puzzleData = data?.data;
          const puzzleDim = data?.data?.size;
          setPuzzle(puzzleData);
          setDim(puzzleDim);
          setIsSubmitted(true);
          setStatus('submitted');

          const solutionStateData = gameSolutionData?.stateConnect;
          const solutionConnectData = solutionStateData?.connectData?.connectData;
          const solutionCompletionTime = (solutionStateData?.completionTimeInMillis ?? 0) / 1000;

          applyConnectSolutionData(puzzleData, puzzleDim, solutionConnectData, solutionCompletionTime);
          setLoader(false);
        })
        .catch(err => {
          console.log(err);
          setLoader(false);
        });
      }
    }, [viewSolution, gameSolutionData, gamejsonUrl]);

  return (
    <>
    <div
      className={`${s.pageWrapper} ${dimClass} ${
        !showCongrate ? 'ConnectGame' : s.connectGameCongratsPage
      }
      ${isWebView && (theme && theme==='light' ? `${s.appLightThemeConnect} appLightThemeConnect` : `${s.appDarkThemeConnect} appDarkThemeConnect`) }
      ${isWebView  ? s.appViewConnect : '' }
      ${isResultView ? s.resultCongratsPage : ''}`}
    >
      {/* Toast message */}
      <div className="contentwrapper clearfix">
        {!viewSolution && !isWebView && 
          breadCrumbData &&
          showCongrate &&
          !isMobile &&
          !isGameIframe && (
            <BreadCrumb data={breadCrumbData} wrapperClass="breadcrumb" />
          )}
        {showLoader && (
          <div className={s.loaderouter}>
            <LoaderSpinner />
          </div>
        )}
        {!viewSolution && !isWebView && !showCongrate &&(
        <div className={s.title}>
          <h1>
            {props.gamesmetawidget?.metaInfo?.TemplateH1TopHeading?.value}
          </h1>
          {!isGameIframe &&
            !isMobile && (
              <ShareButton
                url={`${TOI_LIVE_DOMAIN}/games/connect/today`}
                gaCat="Sudoku"
                gaOnClick={() => {
                  fireGa('share', 'game');
                }}
              />
            )}
        </div>
        )}
        {showOverlay && (
          <GameOverlay
            isGameIframe={isGameIframe}
            iframeSource={iframeSource}
            iframeLangSource={iframeLangSource}
            iframeLang={iframeLang}
            commonTranslations={commonTranslations}
            gameSpecificTranslations={gameSpecificTranslations}
            popUpType={popUpType}
            gameOverlayCallback={gameOverlayCallback}
            callonContinue={callonContinue}
            gameType="connect"
            gameId={gameId}
            gameLevel={levelData?.level?.toLowerCase()}
            isMobile={isMobile}
            isWebView={isWebView}
            theme={theme}
            failedAPI={failedAPI}
          />
        )}
        {!showCongrate && !isResultView && !viewSolution && (
          <div id="til4-timeBlock" className={s.timeBlock}>
            <div className={s.left}>
              <strong>{formatTime(timer)}</strong>
            </div>
            <div className={s.right}>
              <div className={s.actionWrap}>
                {!viewSolution && !isWebView && (
                  <div
                    className={s.circle}
                    onClick={() => !isSubmitted && hardPause()}
                  >
                    <i className={`${s.icon} ${s.pause}`} />
                  </div>
                )}
                {!viewSolution && (
                  <div
                    className={s.circle}
                    onClick={() => {
                      if (!isSubmitted) {
                        let storedValue;
                        if (isGameIframe && iframeSource) {
                          storedValue = JSON.parse(
                            localStorage.getItem(`${iframeSource}games`) || '{}',
                          );
                        } else {
                          storedValue = JSON.parse(
                            localStorage.getItem('toigames') || '{}',
                          );
                        }
                        if (storedValue.resetPopUpConnect) {
                          onReset();
                          fireGa4andGrx(
                            'play_again',
                            'user_click_games',
                            'gameplay',
                            'connect',
                            isMobile,
                            gameId,
                            '',
                            levelData?.level?.toLowerCase(),
                          );
                          return;
                        }
                        resetConfirmation();
                        fireGa4andGrx(
                          'play_again',
                          'user_click_games',
                          'gameplay',
                          'connect',
                          isMobile,
                          gameId,
                          '',
                          levelData?.level?.toLowerCase(),
                        );
                      }
                    }}
                  >
                    <i className={`${s.icon} ${s.reset}`} />
                  </div>
                )}

                {!viewSolution && isMobile && (
                  <div
                    className={s.circle}
                    onClick={() => {
                      if (!isSubmitted && isMobile) {
                        howtoPlay();
                        const gaData = {
                          event: 'user_click_games',
                          type: 'how_to_play',
                          category: 'help_bar',
                          page_template: 'gameplay',
                          section: 'games',
                          subsection: 'connect',
                          browsing_platform: browsingPlatform,
                          game_id: gameId,
                          level: levelData?.level?.toLowerCase(),
                          game_of_the_day: window.location.href
                            .toLowerCase()
                            .includes('/today'),
                          login_status: !!ssoId,
                          user_grx_id: grxId,
                        };
                        if (ssoId) {
                          gaData.sso_id = ssoId;
                        }
                        analyticsWrapper('ga4', gaData);
                        analyticsWrapper(
                          'grx',
                          'track',
                          'user_click_games',
                          gaData,
                        );
                      }
                    }}
                  >
                    <i className={`${s.icon} ${s.question}`} />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {((!viewSolution && !showCongrate) || viewSolution) &&
        <div className={s.connectGameWrap}>
          <div className={s.connectGame}>
            <div className={`${s.connectGameContainer} ${showCongrate || viewSolution ? s.disabledGrid : ''}`}>
              <div>
                <div>
                  <div
                    ref={gridContainerRef}
                    className={s.connectGameBoard}
                    onMouseDown={handleStart}
                    onMouseMove={handleMove}
                    onMouseUp={handleEnd}
                    onMouseLeave={handleEnd}
                    onTouchStart={handleStart}
                    onTouchMove={handleMove}
                    onTouchEnd={handleEnd}
                  >
                    {/* Grid cells */}
                    {Array.from({ length: puzzle.size }, (_, row) =>
                      Array.from({ length: puzzle.size }, (_, col) => {
                        const walls = getCellWallStyles(row, col);
                        const isStart =
                          puzzle.start[0] === row && puzzle.start[1] === col;
                        const isEnd =
                          puzzle.end[0] === row && puzzle.end[1] === col;
                        const isHighlighted =
                          gameState?.highlightedCell &&
                          gameState?.highlightedCell[0] === row &&
                          gameState?.highlightedCell[1] === col;
                        return (
                          <div
                            key={`${row}-${col}`}
                            className={`${s.cell} ${
                              walls.top ? s.topWall : ''
                            } ${walls.right ? s.rightWall : ''} ${
                              walls.bottom ? s.bottomWall : ''
                            } ${walls.left ? s.leftWall : ''
                            }${isCellInPath(row, col) ? ' ' + s.selectedPath : ''} ${isHighlighted ? s.highlightedCell : ''}`}
                            style={{
                              left: `${col * (100 / puzzle.size)}%`,
                              top: `${row * (100 / puzzle.size)}%`,
                              width: `${100 / puzzle.size}%`,
                              height: `${100 / puzzle.size}%`,
                            }}
                          >
                            {/* Start/End markers */}
                            {isStart && (
                              <div className={`${s.startMarker} ${s.marker}`}>
                                <span
                                  className={`${s.startIcon} ${s.markerIcon}`}
                                />
                              </div>
                            )}
                            {isEnd && (
                              <div className={`${s.endMarker} ${s.marker}`}>
                                <span
                                  className={`${s.endIcon} ${s.markerIcon}`}
                                />
                              </div>
                            )}
                          </div>
                        );
                      }),
                    )}
                    {/* SVG path for the road/path (drawn above grid and walls) */}
                    {gameState?.path?.length > 1 && (
                      <svg
                        style={{
                          position: 'absolute',
                          left: 0,
                          top: 0,
                          width: '100%',
                          height: '100%',
                          pointerEvents: 'none',
                          zIndex: 50,
                        }}
                        viewBox={`0 0 ${puzzle.size * 100} ${puzzle.size *
                          100}`}
                        preserveAspectRatio="none"
                      >
                        <polyline
                          points={gameState.path
                            .map(([r, c]) => `${c * 100 + 50},${r * 100 + 50}`)
                            .join(' ')}
                          fill="none"
                          stroke="#64737C"
                          strokeWidth="45"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          filter="drop-shadow(3px 3px 0 #464E52)"
                        />
                        <polyline
                          points={gameState.path
                            .map(([r, c]) => `${c * 100 + 50},${r * 100 + 50}`)
                            .join(' ')}
                          fill="none"
                          stroke="#fff"
                          strokeWidth="2"
                          strokeDasharray="10,17"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {!showCongrate && !isResultView && !viewSolution &&
              <button
                onClick={handleHint}
                disabled={
                  isHintCooldown ||
                  gameState?.path?.length >= puzzle?.solution?.length
                }
                className={`${s.hintButton} ${(isHintCooldown ||
                  gameState?.path?.length >= puzzle?.solution?.length) ? s.disabled : ''}`}
              >
              <span>Hint</span>   <i className={s.hintIcon} />
              </button>
          }
          {toast.show && (
            <div className={s.toastWrapper}>
              <div className={s.toast}>
                {toast.message}
              </div>
            </div>
          )}
          </div>
          {!viewSolution && (!isMobile) && (
            <div className={s.connectGameHowtoplay} id="showtoplaycontent">
              <div className={s.howPlayBlock}>
                <div className={s.title}>
                  <h2>
                    {gameSpecificTranslations?.messages?.howToPlayTitle ||
                      `How to play?`}
                  </h2>
                </div>
                <div className={`${s.howPlayOuter} ${s.br16}`}>
                  <HowToPlay
                    gameType="connect"
                    gaLevel={levelData?.level?.toLowerCase()}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        }
        {pfm && pfm !== '' && ((pfm === 'aos' && fv && fv !== '' && parseInt(fv) >= 1315) || (pfm === 'ios' && fv && fv !== '' && parseInt(fv) >= 1285)) && isResultView && gameSolutionAPIData && gameSolutionAPIData.stateConnect && (
          <div className={`${s.resultContent}`}>        
            <div className={s.timeLine}>
              {gameSolutionAPIData.stateConnect?.completionTimeInMillis !== undefined && 
              <div className={s.timeLineItem}>
                <strong>Time Taken : </strong>
                <span>{formatTimeMMSS(gameSolutionAPIData.stateConnect?.completionTimeInMillis)}</span>
              </div>
              }
              {gameSolutionAPIData.stateConnect?.connectData?.connectData?.hintsUsed !== undefined &&
              <div className={s.timeLineItem}>
                <strong>Hint Used : </strong>
                <span>{gameSolutionAPIData.stateConnect?.connectData?.connectData?.hintsUsed}</span>
              </div>
              }
            </div>
          </div>
        )}
      </div>
    </div>

    {!viewSolution && !isWebView && resultData && (
          <CongratulationsNew
            iframeSource={iframeSource}
            iframeLangSource={iframeLangSource}
            isGameIframe={isGameIframe}
            iframeLang={iframeLang}
            resultData={resultData}
            gameId={gameId}
            showCongrate={showCongrate}
            type="connect"
            subType={levelData?.level?.toLowerCase()}
            playAgainCheck={buttonClicked === 'viewResult' ? '' : false}
            isMobile={isMobile}
            buttonClicked={buttonClicked}
            gameStateData={gameState}
            gamejsonUrl={jsonUrl}
          />
        )}
        <div className={s.gameCardAreaWrapper}>
        {!viewSolution && !isWebView && !isGameIframe &&
          showCongrate && (
            <div className={s.gameCardArea}>
              <div className={s.gameWidget}>
                {/* <div className={s.practiceCard}>
                  <PracticeCard
                    gameType="connect"
                    isLargeCard={!isMobile}
                    subType={levelData?.level?.toLowerCase()}
                    ga4Category="congratulations"
                    gameId={gameId}
                    isMobile={isMobile}
                    gameLevel={levelData?.level?.toLowerCase()}
                  />
                </div>
                <div className={s.gamesListingHeader}>
                  <span>
                    {gameSpecificTranslations?.messages?.moreOn || 'More on'}{' '}
                    <i className={s.moreIcon} />
                  </span>
                </div> */}
                <MoreOnGames
                  gameType="connect"
                  isMobile
                  forceLoadDataOnInit
                  isCogratulationsPage
                  cardProps={{ ga4Category: 'congratulations' }}
                  gameId={gameId}
                  gameLevel={levelData?.level?.toLowerCase()}
                  moreOnGamesTitle="Explore More Games"
                />
              </div>
            </div>
          )}
        </div>
    </>
  );
};

ConnectGame.propTypes = {
  isMobile: PropTypes.bool,
  puzzleAPI: PropTypes.shape({}),
  isToday: PropTypes.bool,
  loadConnectStateSave: PropTypes.func,
  isWebView: PropTypes.bool,
};

ConnectGame.defaultProps = {
  isMobile: false,
  puzzleAPI: {},
  isToday: false,
  loadConnectStateSave: () => {},
  isWebView: false,
};

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  isMobile: state.isMobile,
  isFrmapp: state.isFrmapp,
  puzzleAPI: _get(state, 'toigames.puzzledata', ''),
  gamesmetawidget: _get(state, 'toigames.gamesmetawidget', {}),
  userData: state.login.userData,
  todaysGame: _get(state, 'toigames.puzzledata.todaysGame', ''),
  gamesconfigData: _get(state, 'toigames.gamesconfig', {}),
  apiConfigData: _get(state, 'toigames.gamesconfig.gameCategories.connect', ''),
});

const mapDispatchToProps = dispatch => ({
  loadSyncUp: params => {
    dispatch(loadSyncUp(params));
  },
  loadConnectStateSave: params => {
    dispatch(loadConnectStateSave(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectGame);
